module.exports = __webpack_public_path__ + "static/logo.7336fb12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 84
// module chunks = 35783957827783 166630440199954 271073383855010